import { dayjs } from '@2wunder/klarx-tool'
import { Tooltip } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import KTag from 'app/components/UI-Elements/DataDisplay/KTag'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import * as React from 'react'
import { ComponentProps } from 'react'

type Props = {
  tagProps?: Partial<ComponentProps<typeof KTag>>
}

const Availability: React.FC<MemberProps<ILineItem, Props>> = ({
  member,
  props: { tagProps } = {}
}) => {
  const { tComponent } = useTranslation({
    componentType: 'data_display',
    scope: 'list.availability',
    recordType: RecordType.category_segment
  })
  const startDate = dayjs(member?.startDate)
  const availableDate = dayjs(member?.earliestAvailableDate)
  const available = startDate.isSame(availableDate) || startDate.isAfter(availableDate)

  if (available) {
    return (
      <Tooltip
        title={tComponent({ id: 'available_tooltip' }, { startDate: startDate.toLocaleDate() })}>
        <KTag text={tComponent({ id: 'available' })} color="green" {...tagProps} />
      </Tooltip>
    )
  } else {
    return (
      <Tooltip title={tComponent({ id: 'on_request_tooltip' })}>
        <KTag text={tComponent({ id: 'on_request' })} color="blue" {...tagProps} />
      </Tooltip>
    )
  }
}

export default Availability
